exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.vimeo-iframe-wrapper[data-v-b51464ac] {\n    padding: 56.25% 0 0 0;\n    position: relative;\n}\n", "", {"version":3,"sources":["/codebuild/output/src2207473989/src/src/main/frontend/vue/js/modules/pro/project/components/VimeoPlayer.vue"],"names":[],"mappings":";AACA;IACI,sBAAsB;IACtB,mBAAmB;CACtB","file":"VimeoPlayer.vue","sourcesContent":["\n.vimeo-iframe-wrapper[data-v-b51464ac] {\n    padding: 56.25% 0 0 0;\n    position: relative;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-b51464ac","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/vue/js/modules/pro/project/components/VimeoPlayer.vue
// module id = Eapi
// module chunks = 1 2 3 4 5 6 8 9 10 11 12